var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6582 3.38325C19.9499 3.67492 20.0957 4.02025 20.0957 4.41925C20.0957 4.81747 19.9499 5.16242 19.6582 5.45408L11.1124 13.9999L19.6874 22.5749C19.9596 22.8471 20.0957 23.1874 20.0957 23.5958C20.0957 24.0041 19.9499 24.3541 19.6582 24.6458C19.3665 24.9374 19.0212 25.0833 18.6222 25.0833C18.224 25.0833 17.879 24.9374 17.5874 24.6458L7.78737 14.8166C7.6707 14.6999 7.58787 14.5735 7.53887 14.4374C7.49065 14.3013 7.46653 14.1555 7.46653 13.9999C7.46653 13.8444 7.49065 13.6985 7.53887 13.5624C7.58787 13.4263 7.6707 13.2999 7.78737 13.1833L17.6165 3.35408C17.8888 3.08186 18.224 2.94575 18.6222 2.94575C19.0212 2.94575 19.3665 3.09158 19.6582 3.38325Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.eb54001bf82514dd4f3ad816b8d97243.svg";
export { ForwardRef as ReactComponent };